import { SxProps, Theme } from '@mui/material'

export const useStyles = (): Record<string, SxProps<Theme>> => ({
    pageContainer: {
        maxWidth: 900,
        width: '100%',
        mx: 'auto',
    },
    pageHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 3,
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: '0.875rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: '#94a3b8',
        mb: 1.5,
    },
    infoCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
    },
    dateCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
    },
    damageSection: {
        border: '1px solid rgba(239, 68, 68, 0.2)',
        borderRadius: 2,
        overflow: 'hidden',
    },
    damageHeader: {
        backgroundColor: 'rgba(239, 68, 68, 0.08)',
        px: 2,
        py: 1.5,
    },
    damageTotal: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1.5,
        backgroundColor: 'rgba(255, 255, 255, 0.02)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    },
    videoSection: {
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: 2,
        overflow: 'hidden',
    },
    videoHeader: {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        px: 2,
        py: 1.5,
    },
    dispositionSection: {
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: 2,
        overflow: 'hidden',
    },
    dispositionHeader: {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        px: 2,
        py: 1.5,
    },
    dispositionBody: {
        p: 2,
    },
    dispositionRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 0.75,
    },
    dispositionSubtotal: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pt: 1.5,
        mt: 1.5,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    finalAmountBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 3,
        py: 2.5,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    legalNotice: {
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: 2,
        p: 2,
    },
    actionBar: {
        display: 'flex',
        gap: 1.5,
        pt: 1,
    },
})
